import { StyleSheet } from "react-native";
import { Chip } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import { LeaderboardXpAmount } from "./LeaderboardXpAmount";

type Props = {
	value: number;
	highlighted?: boolean;
};

export const LeaderboardXpBadge = ({ value, highlighted = false }: Props) => {
	const theme = useAppTheme();

	return (
		<Chip
			mode="flat"
			style={{
				...styles.container,
				backgroundColor: highlighted ? undefined : theme.colors.background,
			}}
			textStyle={styles.textContainer}
		>
			<LeaderboardXpAmount
				value={value}
				numberStyle={{
					color: highlighted ? theme.colors.primary : undefined,
				}}
				unitStyle={{
					...styles.xp,
					color: highlighted ? theme.colors.primary : theme.colors.secondary,
					opacity: highlighted ? 0.75 : 1,
				}}
			/>
		</Chip>
	);
};

const styles = StyleSheet.create({
	container: {
		borderRadius: 99,
	},
	textContainer: {
		display: "flex",
		flexDirection: "row",
		alignItems: "flex-end",
		gap: 4,
	},
	xp: {
		lineHeight: 20,
	},
});
